const appRouters: Array<any> = [{
    path: '/foreignexchangecollection',
    name: 'foreignexchangecollection',
    sort: 2,
    meta: { title: 'app.Menu.ForeignExchangeCollection', showAlways:true,  icon: 'md-log-in' },
    component: () => import('../shared/main/index.vue'),
    children: [
        {
            path: 'income', meta: { title: 'app.Income', access: ['RIMS.Income'], icon: '', defaultChild: 'income.list' },
            name: 'income', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.Income', access: ['RIMS.Income'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'income.list', component: () => import('./income/index.vue'),
                },
                {
                    path: 'income', meta: { title: 'app.Income.Income', access: ['RIMS.Income'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'income.income', component: () => import('./income/component/receive-payment.vue'),
                }
                ,
                {
                    path: 'detail', meta: { title: 'Action.Detail', access: ['RIMS.Income.Detail'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'income.detail', component: () => import('./income/component/detail.vue'),
                }
            ]
        },
        {
            path: 'overdue', meta: { title: 'app.Overdue', access: ['RIMS.Overdue'], icon: '', defaultChild: 'overdue.list' },
            name: 'overdue', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'index', meta: { title: 'app.Overdue', access: ['RIMS.Overdue'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'overdue.list', component: () => import('./overdue/index.vue'),
                }
            ]
        }
    ]
}
]

export default appRouters